import React, { useState } from 'react'
import { useAuth0 } from "@auth0/auth0-react";
import './PasswordEntry.css';
import API from '../API';

const PasswordEntry = ({ children }) => {
    const [input, setInput] = useState('');
    const [codeIsValid, setCodeIsValid] = useState(false);
    const { isAuthenticated, isLoading } = useAuth0();

    async function postPasswordEntry() {
        const response = await API.postPasswordEntry(null, { 
            password: input });
        if (response.status !== 204) {
            window.alert("Code is not valid.");
            return;
        }

        setCodeIsValid(true);
    }

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    if (!isAuthenticated && !codeIsValid) {
        // Show enter code screen
        return <div id="divCode" className='ff-modal ff-overlay container vertical-center'>
            <label className='ff-title' htmlFor="inputPassword">Enter portal</label>
            <input value={input} onInput={e => setInput(e.target.value)} id="inputPassword" type="text" onKeyUp={e => { if (e.key === "Enter") { postPasswordEntry();}}} placeholder='&#129395; Enter code' />
            <button className='ff-button' onClick={postPasswordEntry}>Enter World</button>
        </div>;
    }

    return children;
}

export default PasswordEntry;
